import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import i18n from './i18n';
import './index.css';

// Clear any language caches that might be stored
try {
  localStorage.removeItem('i18nextLng');
} catch (e) {
  console.warn('Could not clear language cache:', e);
}

// Force reload translations to ensure they're up to date
console.log('Starting translation reload in main.tsx');
i18n.reloadResources().then(() => {
  console.log('Translations reloaded in main.tsx, rendering app');
  
  // Debug translation values
  console.log('Current language:', i18n.language);
  console.log('WebProgramming translation:', i18n.t('services.webProgramming', { returnObjects: true }));
  console.log('WebProgramming sections translation:', i18n.t('services.sections.webProgramming', { returnObjects: true }));
  console.log('WebDevelopment translation:', i18n.t('services.webDevelopment', { returnObjects: true }));
  
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </StrictMode>
  );
}).catch(err => {
  console.error('Failed to reload translations:', err);
  
  // Render app anyway even if translations failed to reload
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </StrictMode>
  );
});